<app-sidebar-discoveries />
<app-sidebar-sort />
